import { useCallback } from 'react';
import { collectCredentialErrors, pickChangedFieldErrors } from '../credentialV2Utils';

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const validate = (cred) => {
  const errors = {};
  const ref = cred?.data?.reference;

  if (!ref?.contact_email) {
    errors.contact_email = 'Contact email is required';
  } else if (!isValidEmail(ref.contact_email)) {
    errors.contact_email = 'Please enter a valid email address';
  }

  return errors;
};

const hasFieldChanged = (current, original, field) =>
  (current?.data?.reference?.[field] ?? '') !== (original?.data?.reference?.[field] ?? '');

export const useCredentialReference = () => {
  const getErrors = useCallback(
    (current, original) =>
      pickChangedFieldErrors(validate(current), current, original, hasFieldChanged),
    [],
  );

  const validateAll = useCallback(
    (credentials) => collectCredentialErrors(credentials, validate),
    [],
  );

  return { getErrors, validateAll };
};
